import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { CupomCombo, SalvarCupomComboPayload } from './cupom-combo.model';

@Injectable({ providedIn: 'root' })
export class CupomComboService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupomPai: number): Observable<ApiResponse<CupomCombo[]>> {
    return this.http.get<ApiResponse<CupomCombo[]>>(`${this.url}/${nrSeqCupomPai}/combo`);
  }

  criar(nrSeqCupomPai: number, payload: SalvarCupomComboPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupomPai}/combo`, payload);
  }

  atualizar(nrSequencia: number, payload: SalvarCupomComboPayload): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/combo/${nrSequencia}`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/combo/${nrSequencia}`);
  }
}
